import React, { useState, useEffect } from 'react';
import clinicService from '../../../../../services/clinic.service';
import {useParams} from 'react-router-dom';
import ClinicReminderSettingsForm from './ClinicReminderSettingsForm';
import ListSpan from '../common/ListSpan';
import {toast} from 'react-toastify'
const ReminderTab = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const {clinicId} = useParams();
    const [isEditing, setIsEditing] = useState(false);
   
    const [reminderSettings, setReminderSettings] = useState({});

    useEffect(() => {
        setIsLoading(true);

      
        clinicService.getReminderSettings(clinicId)
            .then(res => {
                setIsLoading(false);
                setIsSuccess(true);
                setIsError(false);
                setErrorMessage('');
                setReminderSettings(res.data);
                
            })
            .catch(err => {
                setIsLoading(false);
                setIsSuccess(false);
                setIsError(true);
                setErrorMessage(err.response.data.message);
                toast.error("Error while getting Reminder Settings.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    }, []);

    const updateReminderSettings = (rsettings)=>{
        setReminderSettings(rsettings)
    }
    return ( 
        <>
           
                      
                       <div className="d-flex justify-content-between">
                       <h5 className="card-title" style={{color:"#012970"}}> Clinic Reminder Settings</h5>
                            <div>
                                {isEditing ?
                                <button className="btn btn-secondary btn-sm mt-2"  onClick={()=>setIsEditing(false)}>  
                                    <i className="bi bi-x-square bi-sm"></i> Cancel
                                </button>
                                :
                                <button className="btn btn-secondary btn-sm mt-2" onClick={()=>setIsEditing(true)}>  
                                <i className="bi bi-pencil-square bi-sm"></i> Edit
                            </button>
                                }
                            </div>
                            
                        </div>
                        <div className="row">
                            {isLoading ? <div className="loader"></div> : 
                                isEditing ? <ClinicReminderSettingsForm reminderSettings={reminderSettings} updatesettings = {updateReminderSettings}/>:
                                 <>
                                    <div className="col-md-6">
                                        <ul className='list-group-flush'>
                                              <ListSpan 
                                                value={reminderSettings.apptReminder}
                                                text = "Appointment Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isPrebookedReminder}
                                                text = "Prebooked Reminder"
                                            />
                                           
                                             <ListSpan 
                                                value={reminderSettings.isFirstReminder}
                                                text = "First Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isSecondReminder}
                                                text = "Second Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isLastReminder}
                                                text = "Last Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isSameDayReminder}
                                                text = "Same Day Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isClReminder}
                                                text = "Contact Lens Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isClReorder}
                                                text = "Contact Lens Reorder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isBirthday}
                                                text = "Birthday Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isThankyou}
                                                text = "Thank You Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isWelcome}
                                                text = "Welcome Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isEmail}
                                                text = "Email Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isSms}
                                                text = "Sms Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isCall}
                                                text = "Call Reminder"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.apptSummary}
                                                text = "Appointment Summary"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isGlPickup}
                                                text = "Glasses Pickup"
                                            />
                                            <ListSpan 
                                                value={reminderSettings.isClPickup}
                                                text = "Contactlens Pickup"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isFollowup}
                                                text = "Follow Up"
                                            />
                                             <ListSpan 
                                                value={reminderSettings.isClGlSummary}
                                                text = "Contact Lens & Glass Summary"
                                            />
                                        </ul>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Call Preference : <strong>
                                           {(reminderSettings.callPreference ===0 ? "Disabled" : (reminderSettings.callPreference === 1)? "Clinic":"Both")}
                                            </strong></p>
                                            <p>Appointment Summary : <strong>
                                           {(reminderSettings.apptSummary ===0 ? "Disabled" : (reminderSettings.apptSummary === 1)? "Clinic":"Both")}
                                            </strong></p>
                                        <p>Reminder Time:<strong> {reminderSettings.reminderTime}</strong></p>
                                        <p>Same Day Reminder Time: <strong>{reminderSettings.sameDayReminderTime}</strong></p>
                                        <p>Days to Send Prebook Reminder: <strong>{reminderSettings.daysPrebookReminder}</strong></p>
                                        <p>Days to Send First Reminder: <strong>{reminderSettings.daysFirstReminder}</strong></p>
                                        <p>Days to Send Second Reminder: <strong>{reminderSettings.daysSecondReminder}</strong></p>
                                        <p>Minutes Earlier : <strong>{reminderSettings.minutesToAppt} mins</strong></p>
                                      
                                    </div>
                                </> 
                            
                            }
                          
                           
                        </div>

                     
              
        </>
     );
}
 
export default ReminderTab;